var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"display",staticClass:"display",style:({
    top:_vm.start.y - 25 + 'px',
    left:_vm.start.x - 25 + 'px',
    color:_vm.complete?'#fff':'black'
  }),on:{"click":function($event){return _vm.$emit('myClick')}}},[_c('div',{staticClass:"display_box"},[_c('ul',{ref:"box",staticClass:"box_arrow",style:({
        top:-_vm.index * 19 + 'px'
      }),on:{"transitionend":_vm.myEnd}},[_c('i',{staticClass:"arrow_item"},[_vm._v("→")]),_c('i',{staticClass:"arrow_item"},[_vm._v("→")])])]),_c('span',{staticClass:"display_tips"},[_vm._v(_vm._s(_vm.complete ? '已完成' : '下载中...'))])])}
var staticRenderFns = []

export { render, staticRenderFns }